<template>
  <div class="modal saved-messages-modal animated fadeIn">
    <div class="modal-background"></div>
    <div class="modal-card animated fadeInUp">
      <header class="modal-card-head">
        <span class="close-modal" @click="closeModal()">
          <i class="icon icon-close"></i>
        </span>
        <p class="modal-card-title">Create New Saved Message</p>
      </header>
      <section class="modal-card-body">
        <a @click="newMessage()">
          <span>&#x0002B;</span> New Saved Message
        </a>
        <div class="field">
          <div class="control">
            <multiselect v-model="selectedMessage" :options="messages" placeholder="Select Message"
              track-by="id" label="subject" :showLabels="false"></multiselect>
          </div>
        </div>
        <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
          <div class="form-wrapper" v-show="options.showForm">
            <div class="float-label">
              <input type="text" name="subject" id="subject" v-model="form.subject" required>
              <label for="subject">Subject</label>
            </div>
            <div class="float-label">
              <textarea name="message" id="message" v-model="form.body" required></textarea>
              <label for="message">Message</label>
            </div>
          </div>
        </transition>
      </section>
      <footer class="modal-card-foot">
        <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
          <div v-if="options.showForm">
            <button v-if="form.id" class="button is-primary is-large"
              @click="updateMessage()">Update Message</button>
            <button v-if="form.id" class="button is-primary is-large"
              @click="deleteMessage()">Delete Message</button>
            <button v-if="!form.id" class="button is-primary is-large"
              @click="createMessage()">Create Message</button>
            <button class="button is-primary is-outlined is-large"
              @click="closeModal()">Cancel</button>
          </div>
        </transition>
      </footer>
    </div>
  </div>
</template>

<script>
import API from "mixins/api";

export default {
  props: ['options'],
  mixins: [API],
  data() {
    return {
      Events: window.Events,
      form: {
        id: null,
        subject: null,
        body: null,
      },
      selectedMessage: 1,
      messages: []
    };
  },
  beforeMount() {
    this.refreshSavedMessages();

    this.Events.$on('createSavedMessage', this.refreshSavedMessages);
    this.Events.$on('updateSavedMessage', this.refreshSavedMessages);
    this.Events.$on('deleteSavedMessage', this.refreshSavedMessages);
  },
  destroyed() {
    this.Events.$off('createSavedMessage', this.refreshSavedMessages);
    this.Events.$off('updateSavedMessage', this.refreshSavedMessages);
    this.Events.$off('deleteSavedMessage', this.refreshSavedMessages);
  },
  methods: {
    closeModal() {
      this.Events.$emit("modalClose", "savedMessagesModal");
    },
    resetForm() {
      this.selectedMessage = null;
      this.form = {
        id: null,
        subject: null,
        body: null,
      };
    },
    newMessage() {
      this.resetForm();
      this.options.showForm = true;
    },
    refreshSavedMessages() {
      this.api().fetchSavedMessages()
        .then(messages => this.messages = messages);
    },
    updateMessage() {
      this.api().updateSavedMessage(this.form)
        .then((message) => {
          this.selectedMessage = message;
          (new Notyf()).confirm('Message updated');
        });
    },
    createMessage() {
      this.api().createSavedMessage(this.form)
        .then((message) => {
          this.selectedMessage = message;
          (new Notyf()).confirm('Message created');
        });
    },
    deleteMessage() {
      this.api().deleteSavedMessage(this.form.id)
        .then((result) => {
          this.options.showForm = false;
          this.resetForm();
          (new Notyf()).confirm('Message deleted');
        });
    },
  },
  watch: {
    selectedMessage() {
      this.selectedMessage ? this.form = this.selectedMessage : this.resetForm();
      this.options.showForm = true;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "resources/assets/sass/layout/_variables";
.modal-card {
  min-height: 400px;
}
.fadeIn {
  animation-duration: 500ms;
}
.fadeInUp {
  animation-duration: 500ms;
}
.modal-background {
  background: hsla(0, 0%, 100%, 0.3);
}
</style>



// WEBPACK FOOTER //
// saved-messages-modal.vue?bd757bf8